import React from 'react';
import AdminDashboardContainer from '../components/adminDashboard.container';

/** `/admin` — the overview tiles. Chrome and the access gate live in `admin/AdminRoute.tsx`. */
const AdminPage: React.FC = () => <AdminDashboardContainer />;

export default AdminPage;
